type ParsedNudgeText = {
  boldText: string;
  normalText: string;
};

/**
 * nudge_text HTML을 파싱합니다.
 * 예: "<b>11,000원</b> 비싸져요" → { boldText: "11,000원", normalText: " 비싸져요" }
 */
export const parseNudgeText = (html: string): ParsedNudgeText | null => {
  const match = html.match(/<b>([^<]+)<\/b>(.*)/);
  if (match) {
    return {
      boldText: match[1],
      normalText: match[2],
    };
  }
  return null;
};
